import type { TLeadStatus } from '@shared/types/lead-status';
import leadApi from '@src/features/leads/services/lead-api';
import { InfiniteList } from '@src/design-system/molecules/infinite-list';
import leadStatusApi from '@src/features/leads/services/lead-status-api';
import {
  EditableDropdownCell,
  EditableDropdownCellEditMode,
  EditableDropdownCellItem,
  EditableDropdownCellViewMode,
} from '@src/shared/components/editable-dropdown-cell';
import { deduplicateArr } from '@src/shared/utils/helpers/deduplicate-arr';

export function LeadStatusCell({
  leadId,
  status,
}: {
  leadId: number;
  status?: TLeadStatus;
}) {
  const { mutateAsync: updateLead, variables } = leadApi.useUpdate();
  const optimisticStatus = variables?.tanstackMeta?.status ?? status;

  return (
    <EditableDropdownCell>
      <EditableDropdownCellViewMode>
        {optimisticStatus?.name || '-'}
      </EditableDropdownCellViewMode>

      <EditableDropdownCellEditMode>
        <InfiniteList
          transformItems={(items) =>
            optimisticStatus
              ? deduplicateArr([optimisticStatus, ...items], 'id')
              : items
          }
          enableSearch
          fetchInfiniteData={leadStatusApi.useFetchInfinite}
          props={{
            listProps: { className: 'gap-0 p-0' },
            listContainerProps: {
              className: 'p-1 max-h-[200px]',
            },
            searchContainerProps: { className: 'p-1 mb-1' },
            searchInputProps: {
              size: 'xs',
              className: 'text-sm placeholder:text-sm',
            },
          }}
          renderItem={(s) => {
            return (
              <EditableDropdownCellItem
                key={s.id}
                isSelected={String(s.id) === String(optimisticStatus?.id)}
                onClick={() =>
                  updateLead({
                    id: leadId,
                    status: s.id,
                    tanstackMeta: { status: s },
                  })
                }
              >
                {s.name}
              </EditableDropdownCellItem>
            );
          }}
        />
      </EditableDropdownCellEditMode>
    </EditableDropdownCell>
  );
}
